import * as React from 'react';

import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';

import { WartsilaEnrichments } from './model';

import { PageLoadingIndicator } from 'core/actionloadingindicator/view';

import { EstimateDetailsCardView } from './estimateDetailsView';
import { MapView } from './mapview';

export const WartsilaEnrichmentsView = SuperCritical(({ model: m } : { model : WartsilaEnrichments }) =>
    <div className="wartsilaenrichments pc-page-fixedwidth">
        <div className="pc-actions-links-header">
            <a className="pc-back-link" href="" onClick={noDefault(() => window.history.back())}>&lt;&lt; Back</a>
        </div>
        <Header model={m} />
        <div className="enrichments-body">
            <MapView model={m.Map} />
            <EstimateDetailsCardView model={m.EstimateDetails} />
        </div>
        <PageLoadingIndicator loading={m.Loading} />
    </div>
);

const Header = SuperCritical(({ model: m } : { model : WartsilaEnrichments }) =>
    <h1 className="enrichments-header pc-page-title">
        <span className="pc-text-label-color">W&#x00e4;rtsil&#x00e4; Enrichments</span>
        <span className="pc-icon-bullet" />
        <span className="vessel-name">{m.PortCall.DisplayVesselIdentifier()}</span>
    </h1>
);



// WEBPACK FOOTER //
// ./apps/wartsila/wartsilaenrichments/view.tsx